import { useState, useEffect } from 'react';
import { api } from '../services/api';

export default function AdGroups() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.listAdGroups()
      .then(data => setGroups(data.ad_groups || []))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">Loading AD groups...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="card">
      <h2>AD Groups</h2>
      <div className="group-list">
        {groups.map((group, idx) => (
          <div key={idx} className="group-item">
            <div className="group-name">{group.name}</div>
            {group.description && <div className="group-desc">{group.description}</div>}
            <div style={{fontSize: '0.8rem', color: '#95a5a6', marginTop: '0.25rem'}}>{group.full_ad_name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
